import { mount, unmount } from 'svelte';

import App from './app.svelte';

declare global {
  var didMount: boolean | undefined;
}

let app: Record<string, unknown> | undefined;
const target = document.querySelector<HTMLDivElement>('body>#app')!;

if (!globalThis.didMount) {
  app = mount(App, { target });
}

globalThis.didMount = true;

if (import.meta.hot) {
  import.meta.hot.accept(async () => {
    if (!app) return;
    const previousApp = app;
    app = undefined;
    await unmount(previousApp, { outro: true });
    app = mount(App, { target });
  });
}
